<template>
  <div>
    <!-- 修改弹窗 -->
    <div class="modify">
      <el-dialog
        :title="obj.title"
        :visible.sync="dialogVisibleObj.prompt"
        :close-on-click-modal="false"
        :before-close="downfun"
      >
        <div class="mian" v-if="dialogType == 'null'">
          <p>
            您好! 您购买的卫教云系统使用有效期至
            <span
              >{{ obj.endtime }}，已不足{{
                obj.endtimeType == 1 ? "一周" : "二个月"
              }}</span
            >
            。
          </p>
          <p>
            为保证不影响您的使用，还请及时联系服务人员或练习卫教云官方进行续费。
          </p>
          <p>
            卫教云官方联系电话:15878893290
          </p>
        </div>
        <div v-else-if="dialogType == 1" class="mian_renewal">
          <p>
            <span>用户名：</span>
            {{ obj.realName }}
          </p>
          <p>
            <span>机构名称：</span>
            {{ obj.hospitalName }}
          </p>
          <p>
            <span>续费价格：</span>
            {{ obj.price }}/年
          </p>
          <p>
            <span>续费年限：</span>
            <el-select v-model="renewalNum" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </p>
          <p>
            <span>续费金额：</span>
            {{ obj.price * Number(renewalNum) }}({{ renewalNum }}年)
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="renewal" v-if="dialogType == 1" class="xufei"
            >进行续费</el-button
          >
          <el-button
            @click="
              dialogVisibleObj.prompt = false;
              dialogType = 'null';
            "
            >{{ dialogType == 1 ? "取消" : "确定" }}</el-button
          >
          <el-button
            type="primary"
            v-if="obj.type == '直销' && dialogType == 'null'"
            @click="
              dialogType = 1;
              renewalNum = '1';
            "
            >立即自动续费</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 支付弹窗 -->
    <div class="modify">
      <el-dialog
        :visible.sync="dialogVisibleObj.payOperation"
        :close-on-click-modal="false"
        :before-close="downfun2"
      >
        <div slot="title" class="header-title">
          <img src="../assets/yunlogo.png" alt="" />
        </div>
        <div class="mian_qr" v-if="payState == 'null'">
          <div class="prompt">请核对支付信息</div>
          <p><span>机构名称：</span> {{ obj.hospitalName }}</p>
          <p><span>付费内容：</span> 卫教云账户续费({{ renewalNum }}年)</p>
          <p>
            <span>续费金额：</span> {{ obj.price * Number(renewalNum) }}({{
              renewalNum
            }}年)
          </p>
          <vueqr :text="config.value" :size="240" ref="isAn"></vueqr>
          <img src="../assets/wx.webp" alt="" class="logo" />
        </div>
        <div v-else-if="payState == 1" class="mian_qr">
          <p>支付失败,请检查后再次尝试</p>
          <p>若您还有其他需求，请随时联系我们。</p>
          <p>
            卫教云官方联系电话:15878893290
          </p>
        </div>
        <div v-else-if="payState == 2" class="text_view">
          <p>支付成功,现您的使用有效期已延长至</p>
          <span>{{ overdueTime }}</span>
          <p>若您需要提供发票或修改合同，请随时联系我们。</p>
          <p>
            卫教云官方联系电话:15878893290
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="payState = 1"
            class="xufei"
            v-if="payState == 'null'"
            >支付遇到问题</el-button
          >
          <el-button @click="whetherPayState(true)" v-if="payState == 'null'">
            完成支付</el-button
          >
          <el-button v-if="payState !== 'null'" @click="shutDown"
            >确定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import vueqr from "vue-qr";
import loginvuex from "@/store/index";
import systemclass from "@/api/systemclassification";
export default {
  props: [],
  data() {
    return {
      dialogVisibleObj: {
        prompt: false, //弹窗
        payOperation: false
      },
      renewalNum: "1",
      config: {
        //二维码内的信息
        value: "1", //显示的值、跳转的地址
        imagePath: require("../assets/yunlogo.png") //中间logo的地址
      },
      options: [
        {
          label: "1年",
          value: "1"
        }
      ],
      titleName: "",
      dialogType: "null",
      payState: "null", // 支付状态 1失败 2成功
      orderNo: "", // 查询是否支付成功
      timer: null, // 定时器
      overdueTime: "null"
    };
  },
  props: ["obj"],
  components: {
    vueqr
  },
  methods: {
    // 进行续费
    async renewal() {
      this.dialogVisibleObj.prompt = false; // 关闭弹窗
      let obj = {
        OperatUserID: JSON.parse(loginvuex.state.userlist).userID,
        years: this.renewalNum,
        guid: JSON.parse(loginvuex.state.userlist).guid
      };
      const { data } = await systemclass.createOrder(obj);
      if (data.Status == 200) {
        this.config.value = data.Data.code_url;
        this.orderNo = data.Data.orderNo;
        this.dialogVisibleObj.payOperation = true; // 开启支付二维码弹窗
        this.whetherPayState(); // 开始查询是否支付成功
      } else {
        this.$message.error(data.Data);
      }
      console.log(data);
    },
    // 查询是否支付成功
    whetherPayState(fang) {
      this.timer = setTimeout(
        async () => {
          let obj = {
            OperatUserID: JSON.parse(loginvuex.state.userlist).userID,
            orderNo: this.orderNo,
            guid: JSON.parse(loginvuex.state.userlist).guid
          };
          // 此处定义十秒查询一次   0支付中，1支付成功  其他支付失败
          const { data } = await systemclass.orderCheck(obj);
          if (data.Status == 200) {
            if (data.Data.status == 1) {
              this.completePay(); // 支付成功
            } else if (fang == true && data.Data.status !== 1) {
              this.payState = 1; // 手动点击查询，支付失败弹窗出现
            } else {
              // 支付中继续自动定时查询
              this.whetherPayState();
            }
            console.log(data, "-----------支付成功了");
          } else {
            this.$message.error(data.Data);
          }
        },
        fang == true ? 500 : 10000
      );
    },
    //弹窗一关闭
    downfun() {
      this.dialogVisibleObj.prompt = false;
      this.dialogType = "null";
    },
    // 弹窗二关闭
    downfun2() {
      this.$confirm(
        "是否确定关闭支付码？若关闭则2分后才能重新创建订单，支付成功确定即可。"
      )
        .then(_ => {
          this.dialogVisibleObj.payOperation = false;
          this.dialogType = "null"; // 重置
          clearInterval(this.timer); // 清除定时器
          this.timer = null;
          done();
        })
        .catch(_ => {});
      return;
    },
    // 完成支付
    completePay() {
      this.payState = "null"; // 状态重置
      this.dialogType = "null";
      clearInterval(this.timer); // 清除定时器
      this.timer = null;
      this.getEffectiveInfo(); // 刷新会员剩余时间
      // this.dialogVisibleObj.payOperation = false
    },
    // 支付是否成功提示框关闭
    shutDown() {
      if (this.payState == 2) {
        this.payState = "null";
        this.dialogType = "null";
        this.dialogVisibleObj.payOperation = false;
        clearInterval(this.timer);
        this.timer = null;
      } else {
        // 支付失败重置状态，不关闭弹窗
        this.payState = "null";
      }
    },
    // 获取系统有效期信息
    async getEffectiveInfo() {
      let obj = {
        OperatUserID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.userlist).hid
      };
      const { data } = await systemclass.timeCheck(obj);
      if (data.Status == 200) {
        this.overdueTime = data.Data.endtime; // 到期时间
        this.$parent.endtime = data.Data.endtime; // 更新父组件的续费后到期时间
        this.payState = 2; // 唤起完成支付弹窗
        sessionStorage.setItem("xufeiInfo", JSON.stringify(data.Data));
      } else {
        this.$message.error(data.Msg);
      }
    }
  },
  created() {
    var arr2 = [];
    for (var i = 1; i < 11; i++) {
      arr2.push(i);
    }
    this.options = arr2.map(item => {
      let obj = {
        label: `${item}年`,
        value: String(item)
      };
      return obj;
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}
::v-deep .el-dialog__header {
  min-height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }
    &:nth-child(2) {
      background: #0084ea;
    }
  }
}
.modify {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
    width: 100% !important;
    > .el-button {
      background: #0084ea;
      &:nth-child(2) {
        width: 120px;
        margin-left: 36px;
      }
    }
  }
  ::v-deep.el-dialog__footer {
    justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    align-items: center;
    padding: 0 28px;
    p {
      font-size: 18px;
      //   width: 120px;
      line-height: 24px;
      letter-spacing: 1px;
      span {
        font-weight: bold;
      }
    }
    ::v-deep .el-input__inner {
      width: 280px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 420px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
      }
    }
  }
}
.xufei {
  width: 120px !important;
}
.mian_renewal {
  p {
    font-size: 18px;
    margin-bottom: 10px;
    span {
      width: 90px;
      display: inline-block;
      margin-right: 10px;
    }
  }
}
.mian_qr {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .prompt {
    width: 160px;
    text-align: center;
    height: 46px;
    font-size: 16px;
    // border: 1px solid #000;
    font-weight: bold;
    margin-bottom: 20px;
    box-sizing: border-box;
    padding: 10px 10px;
    letter-spacing: 2px;
  }
  p {
    width: 280px;
    font-size: 18px;
    margin-bottom: 10px;
    span {
      width: 90px;
      display: inline-block;
      margin-right: 10px;
    }
  }
  .logo {
    width: 25px;
    height: 25px;
  }
}
.text_view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    font-size: 16px;
    // text-align: center;
    margin-bottom: 10px;
    width: 280px;
  }
  span {
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: bold;
  }
}
::v-deep .el-message-box .el-message-box__header {
  line-height: 0 !important;
  background: #fff !important;
}
::v-deep .el-message-box__header {
  padding: 0 !important;
  position: inherit;
}
::v-deep .el-message-box {
  width: 300px !important;
}
</style>
<style lang="scss">
// ::v-deep .el-message-box .el-message-box__header {
//   line-height: 0 !important;
//   background: #fff !important;
// }
// .el-message-box__header {
//   // padding: 0 !important;
//   position: inherit;
// }
.el-message-box__headerbtn {
  display: none;
}
// .el-message-box {
//   width: 300px !important;
// }
</style>
